import React from "react"

import Home from "../components/Home"

const IndexPage = () => <Home />

export default IndexPage
